import {
  AsyncPropSelector,
  AppContext,
  StatusTag,
  BackgroundIcon,
  CLIENT_VIEWS,
  SuperPop,
  getTranslatedText,
  Loader,
  InlineEdit,
  InlineEditTableWrapper,
  useCheckFeatureGating
} from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Edit } from '@styled-icons/material/Edit';
import envConfig from '@nile/home/src/Config/env';
import React, { useCallback, useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isEqual } from 'lodash';
import { SVGIcon } from '@superops/super-icons';
import { OFFERING_TYPES } from '@nile/banyan/src/Pages/Constants/offeringType';

const Wrapper = styled.div`
  .editable-cell {
    overflow: hidden;
    height: 100% !important;
    max-height: 38px;

    .value_selector__control--menu-is-open {
      border: none !important;
    }
  }
  .inline-edit--editview__wrapper {
    margin-left: -2px;
  }
  .inline-edit--readview-wrapper {
    width: 100%;
  }

  .inline-edit--readview:hover {
    ${(props) => props.editable && `background: #ffffff !important;`}
  }
  .inlineSelect {
    justify-content: space-between;
    width: 90%;
  }
`;

function ServiceItemCell(props) {
  const { cell, intl } = props;
  const allProps = cell.column;
  const rowData = cell?.row?.original || {};
  const { view, actions, field } = allProps;
  const isEditable = cell?.column?.isEditable;

  const contractsNew = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  function getVariables() {
    if (contractsNew) {
      const contractId = rowData.ticket
        ? rowData.ticket?.contractTicketMapping?.find(
            (ticketMap) => ticketMap.inUse
          )?.contract?.contractId
        : rowData.project?.contract?.contractId;

      return {
        input: {
          ...(contractId && {
            contract: {
              contractId
            }
          }),
          listInfo: {}
        }
      };
    }
    return {
      clientId: rowData.client.accountId,
      listInfo: {}
    };
  }

  function handleSelectedStatus(field, val) {
    if (!isEqual(val.itemId, rowData.serviceCatalogItem.itemId)) {
      actions.updateAudit(
        rowData,
        contractsNew ? 'serviceCatalogItem' : 'serviceItem',
        {
          itemId: val.itemId
        },
        () => {}
      );
    }
  }

  const displayVal = rowData.serviceCatalogItem?.name;

  return (
    <Wrapper editable={isEditable} className="fw">
      <div className="ellipsis flex col center jcenter fw fhp">
        <div className={`flex center fw ${isEditable ? 'editable-cell' : ''}`}>
          <span className="ml-10 mr-10">
            {contractsNew ? (
              <SVGIcon
                name={
                  OFFERING_TYPES[rowData?.serviceCatalogItem?.itemType]?.icon ||
                  OFFERING_TYPES[
                    rowData?.serviceCatalogItem?.serviceTypeItem
                      ?.offeringType || 'PRODUCT'
                  ]?.icon
                }
              />
            ) : rowData.serviceItem.quantityType !== 'UNITS' ? (
              <SVGIcon name="Worklog" />
            ) : (
              <SVGIcon name="Quantity" />
            )}
          </span>
          <InlineEditTableWrapper className="w-80" key={cell?.value}>
            <InlineEdit
              editable={isEditable}
              autoSave
              showProgress
              editView={(fieldProps) => {
                return (
                  <div className="pl8 pr8 mw-100 min-height-40">
                    <AsyncPropSelector
                      ticket={rowData}
                      field={field}
                      entity="whiteListedServiceItem"
                      variables={getVariables()}
                      hideTitle
                      defaultMenuIsOpen
                      updateSelection={handleSelectedStatus}
                      defaultValue={{
                        name: rowData.serviceCatalogItem?.name,
                        label: rowData.serviceCatalogItem?.name,
                        value: rowData.serviceCatalogItem?.name
                      }}
                    />
                  </div>
                );
              }}
              readView={() => {
                return (
                  <div className="flex center full-height inlineSelect mw-100 min-height-40">
                    <div
                      className="full-height ellipsis self-center"
                      title={displayVal}
                    >
                      {displayVal || <DisabledTag>NA</DisabledTag>}
                    </div>
                    {isEditable && (
                      <div className="action-button">
                        <div
                          className="ml8 fx center"
                          onClick={() => togglePopoverActive()}
                        >
                          <SVGIcon name="Edit" />
                        </div>
                      </div>
                    )}
                  </div>
                );
              }}
              onConfirm={(value, callback) => {
                if (!value) {
                  callback(null);
                } else {
                  callback('success');
                }
              }}
            />
          </InlineEditTableWrapper>
        </div>
        {rowData.afterHours && (
          <StatusTag
            className="pl10 mt5 self-start"
            statusObject={{ color: '#D8D8D8' }}
          >
            <FormattedMessage id="client.invoiceAudit.serviceItem.afterHour" />
          </StatusTag>
        )}
        {view === CLIENT_VIEWS.invoiceAudit && rowData.eligibleBlockHour && (
          <div className="pl10 self-start">
            <SuperPop
              position="top-start"
              content={getTranslatedText(
                intl,
                'client.invoiceAudit.eligibleBlockHour.superTip'
              )}
              holder={
                <StatusTag
                  className="mt5 self-start"
                  statusObject={{ color: '#D8D8D8' }}
                >
                  <FormattedMessage
                    id="client.invoiceAudit.serviceItem.remainingBlockHours"
                    values={{ hour: rowData.eligibleBlockHour }}
                  />
                </StatusTag>
              }
            />
          </div>
        )}
        {view === CLIENT_VIEWS.invoiceAudit && rowData.eligibleBlockMoney && (
          <div className="pl10 self-start">
            <SuperPop
              position="top-start"
              content={getTranslatedText(
                intl,
                'client.invoiceAudit.eligibleBlockMoney.superTip'
              )}
              holder={
                <StatusTag
                  className="mt5 self-start"
                  statusObject={{ color: '#D8D8D8' }}
                >
                  <FormattedMessage
                    id="client.invoiceAudit.serviceItem.remainingBlockMoney"
                    values={{ money: rowData.eligibleBlockMoney }}
                  />
                </StatusTag>
              }
            />
          </div>
        )}
        {rowData.adjustedBlockHour && (
          <div className="pl10 self-start">
            <SuperPop
              position="top-start"
              content={getTranslatedText(
                intl,
                'client.invoiceAudit.adjustedBlockHour.superTip'
              )}
              holder={
                <StatusTag
                  className="mt5 self-start"
                  statusObject={{ color: '#D8D8D8' }}
                >
                  <FormattedMessage
                    id="client.invoiceAudit.serviceItem.adjustedBlockHours"
                    values={{ hour: rowData.adjustedBlockHour }}
                  />
                </StatusTag>
              }
            />
          </div>
        )}
        {rowData.adjustedBlockMoney && (
          <div className="pl10 self-start">
            <SuperPop
              position="top-start"
              content={getTranslatedText(
                intl,
                'client.invoiceAudit.adjustedBlockMoney.superTip'
              )}
              holder={
                <StatusTag
                  className="mt5 self-start"
                  statusObject={{ color: '#D8D8D8' }}
                >
                  <FormattedMessage
                    id="client.invoiceAudit.serviceItem.adjustedBlockMoney"
                    values={{ money: rowData.adjustedBlockMoney }}
                  />
                </StatusTag>
              }
            />
          </div>
        )}
      </div>
    </Wrapper>
  );
}

export default injectIntl(ServiceItemCell);
